import PRODUCT_CONSTANT from './product.constant';

export default [{
  state: 'products',
  config: {
    url: `/products?${PRODUCT_CONSTANT.FILTER_PARAMS}`,
    component: 'productList',
    reloadOnSearch: false,
  },
}, {
  state: 'product',
  config: {
    url: `/product/:gender/:id?${PRODUCT_CONSTANT.FILTER_PARAMS}`,
    component: 'productDetail',
    reloadOnSearch: false,
  },
}, {
  state: 'productRelated',
  config: {
    url: `/product/:gender/:id/related/:type?${PRODUCT_CONSTANT.FILTER_PARAMS}`,
    component: 'productRelated',
    reloadOnSearch: false,
  },
}, {
  state: 'productCheck',
  config: {
    url: `/product/:gender/:id/check/:type?${PRODUCT_CONSTANT.FILTER_PARAMS}`,
    component: 'productCheck',
    reloadOnSearch: false,
  },
}];



// WEBPACK FOOTER //
// ./src/app/product/product.routes.js